import { Box } from '@mui/material'
import { useContext, useEffect } from 'react'

// others
import { CardBox } from '../theme/styleComponents'
import { flexCenter } from '../theme/styleConstants'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { useFeeTypes } from '../hooks/useFeeTypes'
import { ADD_FEE_TYPE, FEE_TYPES } from '../constants'

// components
import FeeTypeModal from '../components/entries/feeTypes/FeeTypeModal'
import FeeTypeListing from '../components/entries/feeTypes'
import { EmptyData } from '../components/common/EmptyData'
import { ContentHead } from '../components/common/ContentHead'
import { SearchWithKeypress } from '../components/common/SearchWithKeypress'

const FeeTypeContainer = () => {
  const { feeTypes, pagination, loading, refetch } = useFeeTypes({})
  const { isOpen, dispatch } = useContext(AppContext)

  const isEmpty = !loading && feeTypes.length === 0
  const searchText = 'Search Fee Types'

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })
  
  useEffect(()=>{
    dispatch({type: ActionType.SET_CURRENT_PAGE, currentPage: pagination?.page || 1})
    dispatch({type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: pagination?.totalPages || 1})
  },[dispatch, pagination?.page, pagination?.totalPages])
  
  return (
    <CardBox marginTop={3}>
      <ContentHead title={FEE_TYPES} buttonText={ADD_FEE_TYPE} backButton/>

      <Box display={'flex'} justifyContent={'flex-start'} m={2}>
        <SearchWithKeypress searchPlaceholder={searchText} />
      </Box>

      { isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
            <EmptyData title={'No Categories!'} />
          </Box>
        ) : (
          <FeeTypeListing feeTypes={feeTypes} loading={loading} refetch={refetch} />
        )
      }
      <FeeTypeModal isOpen={isOpen} handleClose={handleClose} refetch={refetch} />
    </CardBox>
  )
}

export default FeeTypeContainer